import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { DecimalService } from 'src/app/shared/service/decimal.service';
import { WalletDetailsData, WalletService } from '../wallet.service';

@Component({
  selector: 'wallet-details',
  standalone: true,
  imports: [NgClass, CSButtonComponent, PipesModule],
  templateUrl: './wallet-details.component.html',
  styleUrl: './wallet-details.component.scss',
})
export class WalletDetailsComponent implements OnInit {
  constructor(
    private decimalService: DecimalService,
    public walletService: WalletService,
    private appService: AppService,
    private router: Router,
  ) {}

  item: WalletDetailsData | null = this.walletService.walletDetailsData || null;

  receivedAmount: string | null = null;

  ngOnInit(): void {
    if (this.item?.data.amount === undefined) return;

    // 後端回傳的 amount 已經減去平台手續費了，故要再減去鏈上手續費(network fee)
    const amount = this.decimalService.toFixed(this.item?.data.amount) || '0';
    const coinFee = this.decimalService.toFixed(this.item?.data.coinFee) || '0';
    this.receivedAmount = this.decimalService.minus(amount, coinFee);
  }

  close() {
    this.walletService.closeWallet();
  }

  jumpToTransactions(type: 'deposit' | 'withdrawal' = 'withdrawal') {
    this.router
      .navigate([this.appService.languageCode, 'transactions', type], {
        queryParams: {},
        fragment: undefined,
      })
      .then(() => {
        this.close();
      });
  }
}
